<template>
    <div :class="['dropdown', open && 'show']" @keydown="onKeydown">
        <button
            ref="toggle"
            type="button"
            :class="['btn', `btn-${variant}`, size && `btn-${size}`, !noCaret && 'dropdown-toggle', toggleClass]"
            :disabled="disabled"
            aria-haspopup="true"
            :aria-expanded="String(open)"
            @click="toggle"
        ><slot name="button-content">{{ text }}</slot></button>
        <div :class="['dropdown-menu', right && 'dropdown-menu-right', menuClass, open && 'show']"><slot /></div>
    </div>
</template>
<script>
export default {
    name: "SbDropdown",
    emits: ["show", "shown", "hide", "hidden"],
    provide() { return { sbDropdown: this }; },
    props: {
        text: { type: String, default: "" },
        variant: { type: String, default: "secondary" },
        size: { type: String, default: null },
        right: { type: Boolean, default: false },
        menuClass: { type: [String, Array, Object], default: null },
        toggleClass: { type: [String, Array, Object], default: null },
        noCaret: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
    },
    data() { return { open: false }; },
    mounted() { document.addEventListener("click", this.onDocumentClick); },
    beforeUnmount() { document.removeEventListener("click", this.onDocumentClick); },
    methods: {
        show() { if (!this.disabled && !this.open) { this.$emit("show"); this.open = true; this.$nextTick(() => this.$emit("shown")); } },
        hide(restoreFocus = false) { if (this.open) { this.$emit("hide"); this.open = false; this.$nextTick(() => { this.$emit("hidden"); if (restoreFocus) { this.$refs.toggle.focus(); } }); } },
        toggle() { this.open ? this.hide() : this.show(); },
        select() { this.hide(true); },
        onDocumentClick(event) { if (this.open && !this.$el.contains(event.target)) { this.hide(); } },
        items() { return [...this.$el.querySelectorAll(".dropdown-item:not(:disabled):not(.disabled)")]; },
        onKeydown(event) {
            if (event.key === "Escape") { this.hide(true); return; }
            if (["Enter", " "].includes(event.key) && document.activeElement?.classList.contains("dropdown-item")) {
                event.preventDefault();
                document.activeElement.click();
                return;
            }
            if (!["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) { return; }
            event.preventDefault();
            if (!this.open) { this.show(); }
            this.$nextTick(() => {
                const items = this.items();
                if (!items.length) { return; }
                const current = items.indexOf(document.activeElement);
                let index = event.key === "Home" ? 0 : event.key === "End" ? items.length - 1 : current + (event.key === "ArrowUp" ? -1 : 1);
                if (index < 0) { index = items.length - 1; }
                if (index >= items.length) { index = 0; }
                items[index].focus();
            });
        },
    },
};
</script>
